<template>
  <div class="mb-3">
    <div
      v-text="title"
      :class="`${headerClass}
        text-center
        py-2
        w-100
        font-weight-bold
        fs_16
        rounded-top`"
    />
    <b-table
      :class="`text-center table-${variant} mb-0`"
      striped
      responsive
      show-empty
      :empty-text="$lang.notRecordExist"
      :fields="fields"
      :items="items"
    />
    <div
      v-if="hasFooter"
      :class="`${footerClass}
        text-center
        py-2
        w-100
        font-weight-bold
        fs_16
        rounded-bottom`"
    >
      <slot name="footer" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      fields: [
        {
          key: "score0",
          label: "",
          class: "text-center",
          thClass: "p-0 border-0 bg-white",
          tdClass: "p-2 text-left",
        },
        {
          key: "score1",
          label: "",
          class: "text-center",
          thClass: "p-0 border-0 bg-white",
          tdClass: "p-2 text-right font-weight-bold dir_ltr",
        },
      ],
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: "",
    },
    footerClass: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "default",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.table-info {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #63c2de1a !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
.table-success {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #4dbd741a !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
.table-primary {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #007bff1a !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
.table-danger {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #ffb6be8c !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
</style>
